import { session } from "../services/session";
import storage from "./storage";

// The real-time view is built up purely from accumulated socket deltas
// (arrival ++, departure --) over a long-lived connection - it has no way
// to self-correct if a single delta is ever missed, duplicated, or arrives
// mid-reconnect. See clusterService.ts's reconcileOnsiteVisitors, which
// calls this to compare against the backend's ground truth.
export const getOnsiteSessions = async (): Promise<any[]> => {
  const response: any = await session({
    jsonprc: "2.0",
    method: "getOnsiteSessions",
    params: {
      siteId: storage.get("siteId"),
    },
    id: 0,
  });

  return response?.data?.result || [];
};
